module.exports = __webpack_public_path__ + "media/images/icon_edit_rounded-44499215ce18950be05728789746bc85.svg";